import React from "react";
import { AlertTriangle } from "lucide-react";
import { ButtonShadcn } from "@/components/ui/Button";

/**
 * Reusable Error component for Handling API Error
 *
 * Theme tokens rather than raw palette classes, so it reads in both themes,
 * and the kit's `tertiary` button, the neutral action every retry wants.
 *
 * @param {string} error - Error Message that come from API / Custom Error message
 * @param {Function} onHandleRetry - Callback to handle retry logic
 */
export const Error = ({ error, onHandleRetry }) => {
  return (
    <div className="col-span-2 flex flex-col items-center justify-center py-16 gap-3">
      <AlertTriangle className="w-10 h-10 text-tone-rose" strokeWidth={1.5} aria-hidden="true" />
      <p className="text-tone-rose text-sm">{error}</p>
      <ButtonShadcn variant="tertiary" size="sm" onClick={onHandleRetry}>
        Try again
      </ButtonShadcn>
    </div>
  );
};
